module.exports = __webpack_public_path__ + "img/Ear.825270f.png";